function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Welcome screen (COMMERCE_ONBOARDING · Task A) — the first-run greeting.
// Top-tier styling shared with Setup/Tracking via onboarding-css. Plain-language
// "what we'll need", a time estimate, and three ways forward.

import React from "react";
import { withRouter } from "react-router";
import PubSub from "pubsub-js";
import account from "../../data/account";
import { dismissOnboarding } from "../../functions/onboarding-status";
import { OB_CSS } from "./onboarding-css";
const NEEDS = [{
  icon: "language",
  title: "Your website",
  body: "Powers the visitor tracker, site monitoring and AI visibility. Just confirm the address.",
  tag: "2 min",
  opt: false
}, {
  icon: "inventory_2",
  title: "Your products",
  body: "A catalog feed, a CSV, or add a few by hand. Feeds keep themselves current.",
  tag: "feed or upload",
  opt: false
}, {
  icon: "receipt_long",
  title: "Your sales history",
  body: "Optional to start, but it's what turns on top sellers, forecasts and store performance.",
  tag: "recommended",
  opt: true
}];
class WelcomeView extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "start", () => this.props.history.push("/Setup"));
    _defineProperty(this, "explore", () => {
      dismissOnboarding();
      this.props.history.push("/");
    });
    _defineProperty(this, "walk", () => {
      PubSub.publish("plunk-assistant-toggle", {
        starter: "Walk me through setting up my workspace."
      });
      this.props.history.push("/Setup");
    });
  }
  render() {
    const acct = account.get() || {};
    const name = acct.account || acct.domain || "there";
    return /*#__PURE__*/React.createElement("div", {
      className: "ob-root"
    }, /*#__PURE__*/React.createElement("style", null, OB_CSS), /*#__PURE__*/React.createElement("div", {
      className: "ob-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-hero"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-mark"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      style: {
        fontSize: 28
      }
    }, "rocket_launch")), /*#__PURE__*/React.createElement("h2", null, "Welcome to Plunk, ", name, ". Let's get your data flowing."), /*#__PURE__*/React.createElement("p", {
      className: "lead"
    }, "We'll connect three things and your analytics, forecasts and marketing switch on. You can do it now, or explore first and pick it up any time from ", /*#__PURE__*/React.createElement("b", null, "Setup"), " in the sidebar."), /*#__PURE__*/React.createElement("div", {
      className: "ob-cta"
    }, /*#__PURE__*/React.createElement("button", {
      className: "ob-btn",
      onClick: this.start
    }, "Start setup"), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ghost",
      onClick: this.explore
    }, "I'll explore first"), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ai",
      onClick: this.walk
    }, "\uD83D\uDCAC Walk me through it")), /*#__PURE__*/React.createElement("p", {
      className: "ob-est"
    }, "About 10 minutes \xB7 nothing here is permanent \xB7 a Plunk rep can do it with you.")), /*#__PURE__*/React.createElement("div", {
      className: "ob-need"
    }, NEEDS.map(n => /*#__PURE__*/React.createElement("div", {
      key: n.title,
      className: "n"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons k"
    }, n.icon), /*#__PURE__*/React.createElement("b", null, n.title), /*#__PURE__*/React.createElement("p", null, n.body), /*#__PURE__*/React.createElement("span", {
      className: `tag${n.opt ? " opt" : ""}`
    }, n.tag))))));
  }
}
export default withRouter(WelcomeView);
export const WelcomeViewComponent = withRouter(WelcomeView);